import ALaCartaComponent from "./aLaCartaComponent";
import {useContext, useState} from "react";
import {CartContext} from "../../pages/shop";


export default function ALaCartaView() {
    const [isCartVisible, setIsCartVisible] = useState(false)
    const {cartData} = useContext(CartContext);

    return (
        <div>
            <main>
                <section className="container container-wide container-single">
                    <section id="" className="ns-bio-hero alignfull">
                        <div className="container ns-bio-hero__info">
                            <div className="ns-bio-hero__info__content flex justify-center items-center">
                                <h1 className="custom-font text-center">À LA CARTE <div className="pt-4">SEO MENU</div></h1>
                            </div>
                        </div>
                        <div className="ns-bio-hero__image">
                            <figure>
                                <img decoding="async"
                                     src="https://images.pexels.com/photos/25987981/pexels-photo-25987981.jpeg"
                                     alt="How to build your SEO Today"/>
                            </figure>
                        </div>
                    </section>
                </section>

                <div className="mb-32" style={{width: "100vw"}}>
                    <ALaCartaComponent/>
                </div>
                { cartData && !(cartData.length === 0) && viewCartButtonBanner()}

            </main>
        </div>
    )

    function viewCartButtonBanner() {
        return (
            <div className="fixed bottom-4 w-full gap-x-6 px-6 py-2.5 sm:px-3.5 sm:before:flex-1">
                <div className="flex justify-center items-center">
                    <div className="bg-gray-900 flex justify-center items-center py-2.5 rounded" style={{width:'70vw'}}>
                        <div className="text-md/6 custom-font">
                            <a className="cursor-pointer text-white" href="/checkout">
                                Proceed to Checkout&nbsp;<span aria-hidden="true">&rarr;</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}